import {useEffect} from "react";
import {useAppDispatch} from "../../../hooks/redux";
import socketService from "../../../middleware/websocketMiddleware";
import {messageDeleted, messageUpserted, reactionsReplaced} from "./slice";
import {chatAfterReconnect, messageArrived} from "./actions";
import {IChatMessage, IDeletedEvent, IReactionsEvent} from "./types";

/**
 * Живые обновления чата (`chat:*` в комнате компании). После переподключения
 * каналы сбрасываются, открытый перечитывается, счётчики — заново с сервера.
 * Подключён один раз на уровне приложения (`AppRealtime`, S4.1); `onOpen` —
 * клик по уведомлению о сообщении.
 */
export function useChatSocket(onOpen?: (channel: string) => void) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const socket = socketService.connect();
        let wasConnected = socket.connected;

        const onMessage = (m: IChatMessage) => dispatch(messageArrived(m, onOpen));
        const onUpdated = (m: IChatMessage) => dispatch(messageUpserted(m));
        const onDeleted = (p: IDeletedEvent) => dispatch(messageDeleted(p));
        const onReactions = (p: IReactionsEvent) => dispatch(reactionsReplaced(p));
        const onConnect = () => {
            if (wasConnected) dispatch(chatAfterReconnect());
            wasConnected = true;
        };

        socket.on("chat:message", onMessage);
        socket.on("chat:message_updated", onUpdated);
        socket.on("chat:message_deleted", onDeleted);
        socket.on("chat:reactions", onReactions);
        socket.on("connect", onConnect);
        return () => {
            socket.off("chat:message", onMessage);
            socket.off("chat:message_updated", onUpdated);
            socket.off("chat:message_deleted", onDeleted);
            socket.off("chat:reactions", onReactions);
            socket.off("connect", onConnect);
        };
    }, [dispatch, onOpen]);
}
